import { render, staticRenderFns } from "./blockColor.vue?vue&type=template&id=da6be2a0"
import script from "./blockColor.vue?vue&type=script&lang=js"
export * from "./blockColor.vue?vue&type=script&lang=js"
import style0 from "./blockColor.vue?vue&type=style&index=0&id=da6be2a0&prod&lang=stylus&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports